var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHigherTitulo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 20",
    width: 8,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 16,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAQCAMAAADtX5XCAAAAAXNSR0IB2cksfwAAAKJQTFRFHHh+HHh+HHh+AAAAHHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+HHh+2rFF9wAAADZ0Uk5TESoBABvLQgnU5Cix/84aYfi8CAd//YADR93zLyHJApaUHJn3SzPPwA494tuRWQTMVRXXflgFZTex3gAAAGtJREFUeJxjZGBkZGRgYGBkYWT8C6LZgfyfQJqZA8j4CqR5GP+wMn5kZBYA0YyMzAz/xRjBNAODJON3MC0N4ctBxJUYnwEFmNUYH8l/fM7IrPmAU+IaA6Me412Vy0BzDRkZL4DsURRmPAekAROkEuGnuA2VAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-higher-titulo"
  }, /*#__PURE__*/React.createElement("use", {
    id: "img1",
    href: "#img1",
    x: 0,
    y: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHigherTitulo);
export default __webpack_public_path__ + "static/media/ico-higher-titulo.00da53ccff0f2619a87c2b5b84c144ad.svg";
export { ForwardRef as ReactComponent };